import configureStore from '../configure_store'
import rootReducer from './reducers'

export const createSubStore = (preloadedState, middleware = []) =>
  configureStore(rootReducer, preloadedState, middleware)
